import React, { memo, useState } from 'react';
import { ImageIcon } from '@saleshandy/design-system';
import { accessibleOnClick } from '../../../../../shared/utils/accessible-on-click';
import { templateEnrichment } from '../utils/helper';
import { AiProspectEnrichmentOptionsProps } from '../type';
import { Images } from '../../../../../shared/app-constants';
import { AiColEnrichmentModalSteps } from '../enums';
import EmbeddedVideoModal from '../../../../email-accounts/modals/embedded-video-modal';
import { supportUrls } from '../../../../../shared/utils/urls';

const AiProspectEnrichmentOptions: React.FC<AiProspectEnrichmentOptionsProps> = memo(
  ({ handleMoveToNextStep }) => {
    const [showYoutubeVideo, setShowYoutubeVideo] = useState(false);
    const getNextStep = (id: string) => {
      switch (id) {
        case 'use-template':
          return AiColEnrichmentModalSteps.TEMPLATE_LIST;
        case 'own-prompt':
          return AiColEnrichmentModalSteps.CUSTOM_PROMPT;
        case 'existing-prospect':
          return AiColEnrichmentModalSteps.EXISTING_COLUMN;
        default:
          return AiColEnrichmentModalSteps.TEMPLATE_LIST;
      }
    };

    return (
      <div className="ai-column-drawer-content">
        <div className="ai-column-header">
          {/* Render template cards or skeleton loading */}
          {templateEnrichment?.map((item) => (
            <div
              key={item?.id}
              className="enrich-option-container"
              {...accessibleOnClick(() =>
                handleMoveToNextStep(getNextStep(item?.id)),
              )}
            >
              <div className="enrichment-title-container">
                <span className="enrichment-title">{item?.title}</span>
                <span className="enrichment-description">
                  {item?.description}
                </span>
              </div>
              <div className="enrichment-navlink-container">
                <span className="enrichment-navlink-text">
                  {item?.navigationLinkText}
                </span>
                <ImageIcon
                  src={Images?.ArrowRightNewGradient}
                  alt="arrow-right-icon"
                  height={16}
                  width={16}
                  className="arrow-icon-gradient"
                />
              </div>
              <img
                src={item.image}
                className="enrichment-image"
                alt={item.title}
              />
            </div>
          ))}
        </div>

        <div className="learn-more-section">
          <div className="what-to-choose">
            <ImageIcon src={Images.BulbBlue} alt="arrow-right-icon" />
          </div>
          <div className="learn-more-text">
            <div className="what-to-choose-title-container">
              <span className="what-to-choose-title">
                Not sure what to choose?
              </span>

              <ImageIcon
                src={Images?.Youtube}
                className="pointer"
                alt="youtube-icon"
                width={16}
                height={16}
                {...accessibleOnClick(() => setShowYoutubeVideo(true))}
              />

              <EmbeddedVideoModal
                show={showYoutubeVideo}
                onClose={() => setShowYoutubeVideo(false)}
                url={supportUrls?.aiProspectEnrichmentURL}
                title="Ai Prospect Enrichment Video"
                scriptSrc="https://fast.wistia.net/player.js"
              />
            </div>
            <span className="what-to-choose-description">
              No worries, we've got you covered. Click to{' '}
              <a
                href="https://docs.saleshandy.com/en/articles/12290754-how-to-use-ai-prospect-enrichment-to-run-hyper-personalized-campaigns"
                target="_blank"
                rel="noopener noreferrer"
                className="learn-more"
              >
                Learn more
              </a>
            </span>
          </div>
        </div>
      </div>
    );
  },
);

export default AiProspectEnrichmentOptions;
